export const charToImage = (userData) => {
  if (userData?.companyName) {
    const firstChar = userData?.companyName[0];

    return <div className="char-to-image">{firstChar.toUpperCase()}</div>;
  }
};
